import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, vModelText as _vModelText } from "vue"
import _imports_0 from './assets/logo_wwt.png'
import _imports_1 from './assets/ip-ussrc.png'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_3 = { class: "hamb-icon-container" }
const _hoisted_4 = {
  key: 1,
  class: "intro-container"
}
const _hoisted_5 = { style: {"font-size":"18px","font-family":"'Roboto'","margin-bottom":"1em"} }
const _hoisted_6 = { class: "checkboxes-container" }
const _hoisted_7 = { class: "center-buttons" }
const _hoisted_8 = {
  key: 2,
  class: "bg-slider-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_wwt_hud = _resolveComponent("wwt-hud")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          onPointerdown: _ctx.wwtOnPointerDown,
          onPointermove: _ctx.wwtOnPointerMove,
          onPointerup: _ctx.wwtOnPointerUp
        }, null, 8, ["wwt-namespace", "onPointerdown", "onPointermove", "onPointerup"]),
        false
          ? (_openBlock(), _createBlock(_component_wwt_hud, {
              key: 0,
              "wwt-namespace": _ctx.wwtNamespace,
              location: {top: '5rem', right: '1rem'},
              "offset-center": {x: 0, y: 0},
              "other-variables": {position3D: _ctx.position3D, position2D: _ctx.position2D, mode: _ctx.modeReactive},
              "text-shadow": "none",
              "font-size": "0.8em"
            }, null, 8, ["wwt-namespace", "other-variables"]))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, _cache[18] || (_cache[18] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _cache[39] || (_cache[39] = _createElementVNode("link", {
          rel: "stylesheet",
          href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "menu-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _cache[19] || (_cache[19] = [
            _createElementVNode("i", {
              class: "fas fa-sliders-h",
              style: {"font-size":"24px"}
            }, null, -1)
          ])),
          _createElementVNode("div", {
            class: _normalizeClass({ fullscreen: _ctx.fullscreen })
          }, [
            _createElementVNode("button", {
              class: "fullscreen-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.fullscreen ? 'fas fa-compress fa-lg' : 'fas fa-expand fa-lg')
              }, null, 2)
            ])
          ], 2),
          _createElementVNode("ul", {
            class: _normalizeClass(["hamb-menu-container", {'show': _ctx.isMenuOpen }])
          }, [
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openIntro && _ctx.openIntro(...args)))
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("i", { class: "fas fa-regular fa-info-circle" }, null, -1),
              _createTextVNode(" Overview ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleBgSlider && _ctx.toggleBgSlider(...args)))
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("i", { class: "fas fa-adjust" }, null, -1),
              _createTextVNode(" Crossfade (2D) ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSkySurveySelector && _ctx.toggleSkySurveySelector(...args)))
            }, _cache[22] || (_cache[22] = [
              _createElementVNode("i", { class: "fas fa-solid fa-star" }, null, -1),
              _createTextVNode(" Choose Sky Survey (2D) ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleLink && _ctx.toggleLink(...args)))
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("a", {
                href: "https://radiostars.org/",
                target: "_blank",
                style: {"text-decoration":"none","color":"inherit"},
                onmouseover: "this.style.textDecoration='none';",
                onmouseout: "this.style.textDecoration='none';"
              }, [
                _createElementVNode("i", { class: "fas fa-solid fa-rocket" }),
                _createTextVNode(" radiostars.org ")
              ], -1)
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleLink && _ctx.toggleLink(...args)))
            }, _cache[24] || (_cache[24] = [
              _createElementVNode("a", {
                href: "https://arxiv.org/abs/2404.07418",
                target: "_blank",
                style: {"text-decoration":"none","color":"inherit"},
                onmouseover: "this.style.textDecoration='none';",
                onmouseout: "this.style.textDecoration='none';"
              }, [
                _createElementVNode("i", { class: "fas fa-regular fa-newspaper" }),
                _createTextVNode(" Driessen et al. (2024) ")
              ], -1)
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleLink && _ctx.toggleLink(...args)))
            }, _cache[25] || (_cache[25] = [
              _createElementVNode("a", {
                href: "https://www.rocketcenter.com/INTUITIVEPlanetarium/InteractiveAstronomy",
                target: "_blank",
                style: {"text-decoration":"none","color":"inherit"},
                onmouseover: "this.style.textDecoration='none';",
                onmouseout: "this.style.textDecoration='none';"
              }, [
                _createElementVNode("i", { class: "fas fa-solid fa-rocket" }),
                _createElementVNode("i", null, " INTUITIVE"),
                _createElementVNode("sup", null, "®"),
                _createTextVNode(" Planetarium ")
              ], -1)
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleLink && _ctx.toggleLink(...args)))
            }, _cache[26] || (_cache[26] = [
              _createElementVNode("a", {
                closeIntro: "",
                href: "https://worldwidetelescope.org/",
                style: {"text-decoration":"none","color":"inherit"},
                onmouseover: "this.style.textDecoration='none';",
                onmouseout: "this.style.textDecoration='none';",
                target: "blank"
              }, [
                _createElementVNode("img", {
                  alt: "WWT Logo",
                  src: _imports_0,
                  width: "18",
                  height: "18",
                  style: {"vertical-align":"middle"}
                }),
                _createTextVNode(" WorldWide Telescope ")
              ], -1)
            ]))
          ], 2)
        ]),
        (_ctx.showIntro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "close-intro",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)))
              }, _cache[27] || (_cache[27] = [
                _createElementVNode("i", {
                  class: "fas fa-times",
                  style: {"font-size":"20px"}
                }, null, -1)
              ])),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.introTitle), 1),
              _cache[28] || (_cache[28] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, " The Sydney Radio Star Catalogue is a catalogue of radio detected stars and stellar binary systems compiled and maintained by a team at the University of Sydney. It includes: main sequence stars, M and K dwarfs, ultracool dwarfs, magnetically chemically peculiar stars, binaries (e.g. symbiotic binaries and RS CVn) and more. It does not include sources such as novae or X-ray binaries. ", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, [
                _createTextVNode(" Included stars have been detected in the radio at least once and are confirmed radio stars. This includes stars that have been detected as circularly polarised radio sources, have radio light curve variability consistent with radio star variability, or are the result of a cross-match with at least 98% reliability. Candidate radio stars are not included. For full details on the construction and inclusions of the catalogue please see "),
                _createElementVNode("a", {
                  href: "https://arxiv.org/abs/2404.07418",
                  target: "_blank",
                  class: "links"
                }, "Driessen et al. (2024)"),
                _createTextVNode(" and peruse the data at "),
                _createElementVNode("a", {
                  href: "https://radiostars.org/",
                  target: "_blank",
                  class: "links"
                }, "radiostars.org.")
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, " In this interactive viewer, the Radio Stars are filterable by their observed frequencies. Toggle between 2D and 3D views for different perspectives in the sky and Milky Way galaxy, respectively. Hover over a unique star to see its name and distance. Crossfade between optical (visible light) and radio wavelengths in the 2D sky. Zoom in both modes and then zoom some more. ", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, [
                _createTextVNode(" Interactive created by "),
                _createElementVNode("a", {
                  href: "https://bsky.app/profile/adavidweigel.bsky.social",
                  target: "_blank",
                  class: "links",
                  style: {"margin-right":"0.5em"}
                }, "A. David Weigel,"),
                _createElementVNode("a", {
                  href: "https://www.linkedin.com/in/erika-s-a37431153/",
                  target: "_blank",
                  class: "links",
                  style: {"margin-right":"0.5em"}
                }, "Érika Silva,"),
                _createElementVNode("a", {
                  href: "https://newton.cx/~peter/",
                  target: "_blank",
                  class: "links",
                  style: {"margin-right":"0.5em"}
                }, "Peter K. G. Williams,"),
                _createTextVNode("and "),
                _createElementVNode("a", {
                  href: "https://www.jcarifio.com/projects",
                  target: "_blank",
                  class: "links",
                  style: {"margin-right":"0.5em"}
                }, "Jon Carifio")
              ], -1)),
              _cache[32] || (_cache[32] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, [
                _createTextVNode(" Special thanks to Faith Williams for UI suggestions and color theory advice and the "),
                _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  class: "links",
                  style: {"margin-right":"0.5em"}
                }, "Cosmic Data Stories"),
                _createTextVNode("team. ")
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, [
                _createTextVNode(" Powered by "),
                _createElementVNode("a", {
                  href: "https://worldwidetelescope.org/home/",
                  target: "_blank",
                  class: "links"
                }, " WorldWide Telescope "),
                _createElementVNode("a", null, [
                  _createElementVNode("img", {
                    alt: "WWT Logo",
                    src: _imports_0,
                    width: "20",
                    height: "20",
                    style: {"vertical-align":"top","margin-left":"0.25em"}
                  })
                ])
              ], -1)),
              _cache[34] || (_cache[34] = _createElementVNode("p", { style: {"margin-bottom":"0.75em"} }, [
                _createElementVNode("a", null, [
                  _createElementVNode("img", {
                    alt: "IP Logo",
                    src: _imports_1,
                    width: "178",
                    height: "102",
                    style: {"vertical-align":"top","margin-left":"0.5em","transform":"translateX(50%)"}
                  })
                ])
              ], -1))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          id: "circle-popover",
          style: _normalizeStyle(_ctx.popoverCssVars)
        }, _toDisplayString(_ctx.lastClosePt?.name) + ", " + _toDisplayString(_ctx.lastClosePt?.gdist.slice(0,6)) + " pc, " + _toDisplayString(_ctx.lastClosePt?.obs), 5), [
          [_vShow, _ctx.lastClosePt !== null]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "catalog-button",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openCatalog && _ctx.openCatalog(...args)))
        }, _toDisplayString(_ctx.showCatalog == true ? 'Collapse  Menu' : 'Filter Radio Stars'), 513), [
          [_vShow, _ctx.showCatalogButton]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "data-label" }, [
              _createElementVNode("p", { style: {"color":"#E3E3E3","font-size":"1.4rem"} }, " Radio Stars "),
              _createElementVNode("p", null, " Observed Frequency ")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.layersOn).sort((freq1, freq2) => Number(freq1) - Number(freq2)), (freq, index) => {
              return (_openBlock(), _createBlock(_component_v_checkbox, {
                key: index,
                color: _ctx.colors[index],
                modelValue: _ctx.layersOn[freq],
                "onUpdate:modelValue": ($event: any) => ((_ctx.layersOn[freq]) = $event),
                onKeyup: _withKeys(($event: any) => (_ctx.layersOn[freq] = !_ctx.layersOn[freq]), ["enter"]),
                label: `${freq.replace('_', '.')} MHz`,
                class: _normalizeClass(`type${index}`),
                "hide-details": ""
              }, null, 8, ["color", "modelValue", "onUpdate:modelValue", "onKeyup", "label", "class"]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.showCatalog]
        ]),
        _createElementVNode("div", _hoisted_7, [
          true
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modeReactive = _ctx.modeReactive == '3D' ? '2D' : '3D'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.modeReactive == '3D' ? '2D Sky View ' : '3D Galaxy View ') + " ", 1),
                _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fas fa-solid fa-rocket" }, null, -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        ((_ctx.showBgSlider || _ctx.showBgButton) && _ctx.modeReactive == '2D')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.currentTool == 'crossfade')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", {
                      class: "bg-slider-text",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.foregroundOpacity = 0)),
                      onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.foregroundOpacity = 0), ["enter"])),
                      tabindex: "0"
                    }, _cache[37] || (_cache[37] = [
                      _createTextVNode("Visible light"),
                      _createElementVNode("br", null, null, -1)
                    ]), 32),
                    _withDirectives(_createElementVNode("input", {
                      class: "opacity-range",
                      type: "range",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.foregroundOpacity) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.foregroundOpacity]
                    ]),
                    _createElementVNode("span", {
                      class: "bg-slider-text",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.foregroundOpacity = 100)),
                      onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.foregroundOpacity = 100), ["enter"])),
                      tabindex: "0"
                    }, _cache[38] || (_cache[38] = [
                      _createTextVNode("Radio waves"),
                      _createElementVNode("br", null, null, -1)
                    ]), 32)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentTool == 'choose-background')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.modeReactive == '2D')
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.fgName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fgName) = $event)),
                          items: _ctx.allSkyImagesets,
                          label: "Background",
                          outlined: "",
                          "hide-details": "",
                          color: _ctx.colorWhite,
                          class: "bg-slider-text"
                        }, null, 8, ["modelValue", "items", "color"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}